import React from 'react';

import DocTypeListItem from './DocTypeListItem';
import { SWrapper } from '../styles/DocTypeList.styled';
import { useAppSelector } from '../../../hooks/customHooks';

const DocTypeList: React.FC = () => {
  const docTypes = useAppSelector((state) => state.docTypes.docTypesByActiveCustomer);

  const renderDocTypes = () =>
    docTypes.map((docType) => <DocTypeListItem key={docType.primaryKey} docType={docType} />);

  return <SWrapper id="ddlDocType">{renderDocTypes()}</SWrapper>;
};

export default DocTypeList;
